const SETT_ABBAR = 'SETT_ABBAR'
const SET_TABS = 'SET_TABS'

export {
    SETT_ABBAR,
    SET_TABS
}